<template>
  <div :class="`svg_${iconName}`" :style="`height: ${iconSize}px; width: ${iconSize}px;`"></div>
</template>

<script>
export default {
  name: 'svg-icon',
  props: {
    iconName: {
      type: String,
      required: true
    },
    iconSize: {
      type: Number,
      required: true
    }
  }
}
</script>
